<template>
  <div class="lg-nav-tabs">
    <v-tabs
      class="tabs"
      v-model="active"
      color="#fff"
      slider-color="accent"
      @change="tabChange"
    >
      <v-tab v-for="tab in settings.tabs" :key="tab.id" ripple>
        {{ tab.label }}
      </v-tab>
    </v-tabs>
    <div class="underline"></div>
  </div>
</template>

<script>
export default {
  name: 'Tabs',
  props: {
    settings: {
      // keys are tabs, preselected, enableRouting
      // preselected is only
      type: Object,
      default: () => {
        return {
          preselected: null, // if not using router, you can preselect upon creation with id
          tabs: []
        }
      }
    }
  },
  created: function() {
    const vm = this
    // setTimeout(function () {
    //     vm.$router.push({name: vm.settings.tabs[2].id})
    // }, 3000)
  },
  data: function() {
    return {
      active: this.settings.preselected
        ? this.settings.tabs.map(d => d.id).indexOf(this.settings.preselected)
        : this.getRouterMatchedTabIndex(this.$router.currentRoute)
    }
  },
  watch: {
    $route(to, from) {
      // beforeRouteUpdate doesn't work
      this.active = this.getRouterMatchedTabIndex(to)
    }
  },
  methods: {
    tabChange: function(tab) {
      this.$router.push({
        name: this.settings.tabs[tab].id,
        query: this.$router.currentRoute.query
      })
    },
    getRouterMatchedTabIndex: function(to) {
      for (let i = 0; i < this.settings.tabs.length; i++) {
        const tmp = to.matched.find(f => f.name === this.settings.tabs[i].id)
        if (tmp) return i
      }
    }
  }
}
</script>

<style lang="stylus">
.lg-nav-tabs {
    width 100%
    position fixed
    top 0
    margin-left: 6px
    z-index 1
    .underline {
        height: 1px;
        background: $color-primary-light-8;
        width: 100%;
        margin-left: -65px;
        position: relative;
    }

    .v-tabs__slider {
        height 3px
    }

    .v-tabs__item:not(.v-tabs__item--active) {
        opacity 1
    }

    .v-tabs__bar .v-tabs__div {
        color $color-primary !important
        font-weight normal

        .v-tabs__item--active {
            font-weight bold
        }
    }
}
</style>
